import React from 'react';
import propTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';
import './ShareFooter.scss';
import { MOBILE, DESKTOP } from '../../utils/widgetInfoDefaults';

const ShareFooter = ({ accountInfo, deviceType, openModal, show, lock }) => {
	const labels = useLabels();

	if (!accountInfo) {
		return null;
	}

	const { dealerCode, name } = accountInfo;
	const shareCopy = labels
		.get('SHARE_YOUR_STORY_DESCRIPTION')
		.replace('$account.name', name);

	const shouldShow = deviceType === MOBILE || show;

	return (
		<div
			className={`lp-share-footer bg-light w-100 ${
				deviceType === DESKTOP && !lock ? 'position-fixed' : ''
			} p-8 ${shouldShow ? '' : 'hide'}`}
		>
			<div className="container">
				<div className="row mx-auto">
					<div className="col-sm-8">
						<p>{shareCopy}</p>
					</div>
					<div className="col-sm-4">
						{deviceType === DESKTOP ? (
							<button
								type="button"
								className={`btn btn-default ${
									lock ? 'btn-lg' : 'btn-block'
								} submit-story-btn`}
								onClick={openModal}
							>
								{labels.get('LOVE_PROMISE_SUBMIT_STORY')}
							</button>
						) : (
							<a
								className="btn btn-default btn-block submit-story-btn"
								href={`https://www.subaru.com/content/subaru/en/love-promise/ddc-love-promisesubmissionform.html?dealerNumber=${dealerCode}`}
							>
								{labels.get('LOVE_PROMISE_SUBMIT_STORY')}
							</a>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

ShareFooter.propTypes = {
	accountInfo: propTypes.shape({
		name: propTypes.string,
		dealerCode: propTypes.string
	}).isRequired,
	deviceType: propTypes.string.isRequired,
	openModal: propTypes.func.isRequired,
	show: propTypes.bool.isRequired,
	lock: propTypes.bool.isRequired
};

export default ShareFooter;
